module.exports = __webpack_public_path__ + "static/media/thermoready-1.42cb0c87.png";